// extracted by mini-css-extract-plugin
export default {"DocumentLists":"DocumentLists_DocumentLists__pdyA7","documentList":"DocumentLists_documentList__sPvku","sortDropDown":"DocumentLists_sortDropDown__KjlV2"};